export default __webpack_public_path__ + "static/media/proj13.c12fdfca.png";